export const LicensesInfo = {
  'cc-by-4.0': {
    key: 'cc-by-4.0',
    name: 'Creative Commons Attribution 4.0 International',
    spdx_id: 'CC-BY-4.0',
    url: 'https://api.github.com/licenses/cc-by-4.0',
    node_id: 'MDc6TGljZW5zZTI1',
    html_url: 'http://choosealicense.com/licenses/cc-by-4.0/',
    description:
      'Permits almost any use subject to providing credit and license notice. Frequently used for media assets and educational materials. The most common license for Open Access scientific publications. Not recommended for software.',
    implementation:
      "Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file. It is also acceptable to solely supply a link to a copy of the license, usually to the <a href='https://creativecommons.org/licenses/by/4.0/'>canonical URL for the license</a>.",
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright', 'document-changes'],
    limitations: ['liability', 'trademark-use', 'patent-use', 'warranty'],
  },
  'cc-by-sa-4.0': {
    key: 'cc-by-sa-4.0',
    name: 'Creative Commons Attribution Share Alike 4.0 International',
    spdx_id: 'CC-BY-SA-4.0',
    url: 'https://api.github.com/licenses/cc-by-sa-4.0',
    node_id: 'MDc6TGljZW5zZTI2',
    html_url: 'http://choosealicense.com/licenses/cc-by-sa-4.0/',
    description:
      'Similar to <a href=\'/licenses/cc-by-4.0/\'>CC-BY-4.0</a> but requires derivatives be distributed under the same or a similar, <a href="https://creativecommons.org/compatiblelicenses/">compatible</a> license. Frequently used for media assets and educational materials. A previous version is the default license for Wikipedia and other Wikimedia projects. Not recommended for software.',
    implementation:
      "Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file. It is also acceptable to solely supply a link to a copy of the license, usually to the <a href='https://creativecommons.org/licenses/by-sa/4.0/'>canonical URL for the license</a>.",
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright', 'document-changes', 'same-license'],
    limitations: ['liability', 'trademark-use', 'patent-use', 'warranty'],
  },
  'tapr-ohl-1.0': {
    key: 'tapr-ohl-1.0',
    name: 'TAPR Open Hardware License v1.0',
    spdx_id: 'TAPR-OHL-1.0',
    url: 'https://spdx.org/licenses/TAPR-OHL-1.0.html',
    node_id: '',
    html_url: 'https://spdx.org/licenses/TAPR-OHL-1.0.html',
    description: '',
    implementation:
      'Include this document in a file named LICENSE (with the appropriate extension) that is included in the documentation package.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: [
      'disclose-source',
      'include-copyright',
      'document-changes',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
  },
  'cern-ohl-1.2': {
    key: 'cern-ohl-1.2',
    name: 'CERN Open Hardware Licence v1.2',
    spdx_id: 'CERN-OHL-1.2',
    url: 'https://spdx.org/licenses/CERN-OHL-1.2.html',
    node_id: '',
    html_url: 'https://spdx.org/licenses/CERN-OHL-1.2.html',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: [
      'disclose-source',
      'include-copyright',
      'document-changes',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
  },
  'cern-ohl-p-2.0': {
    key: 'cern-ohl-p-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Permissive',
    spdx_id: 'CERN-OHL-P-2.0',
    url: 'https://spdx.org/licenses/CERN-OHL-P-2.0.html',
    node_id: '',
    html_url: 'https://spdx.org/licenses/CERN-OHL-P-2.0.html',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
      'patent-use',
    ],
    conditions: ['include-copyright', 'document-changes', 'disclose-source'],
    limitations: ['liability', 'warranty'],
  },
  'cern-ohl-s-2.0': {
    key: 'cern-ohl-s-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Strongly Reciprocal',
    spdx_id: 'CERN-OHL-S-2.0',
    url: 'https://spdx.org/licenses/CERN-OHL-S-2.0.html',
    node_id: '',
    html_url: 'https://spdx.org/licenses/CERN-OHL-S-2.0.html',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
      'patent-use',
    ],
    conditions: [
      'include-copyright',
      'document-changes',
      'disclose-source',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
  },
  'cern-ohl-w-2.0': {
    key: 'cern-ohl-w-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Weakly Reciprocal',
    spdx_id: 'CERN-OHL-W-2.0',
    url: 'https://spdx.org/licenses/CERN-OHL-W-2.0.html',
    node_id: '',
    html_url: 'https://spdx.org/licenses/CERN-OHL-W-2.0.html',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
      'patent-use',
    ],
    conditions: [
      'include-copyright',
      'document-changes',
      'disclose-source',
      'same-license--file',
    ],
    limitations: ['liability', 'warranty'],
  },
  unlicensed: {
    key: 'unlicensed',
    name: 'Unlicensed',
    spdx_id: 'unlicensed',
    url: '',
    node_id: '',
    permissions: [],
    conditions: [],
    limitations: [],
  },
  other: {
    key: 'other',
    name: 'Other license',
    spdx_id: 'other',
    url: '',
    node_id: '',
    permissions: [],
    conditions: [],
    limitations: [],
  },
  'agpl-3.0': {
    key: 'agpl-3.0',
    name: 'GNU Affero General Public License v3.0',
    spdx_id: 'AGPL-3.0',
    url: 'https://api.github.com/licenses/agpl-3.0',
    node_id: 'MDc6TGljZW5zZTE=',
    html_url: 'http://choosealicense.com/licenses/agpl-3.0/',
    description:
      'Permissions of this strongest copyleft license are conditioned on making available complete source code of licensed works and modifications, which include larger works using a licensed work, under the same license. Copyright and license notices must be preserved. Contributors provide an express grant of patent rights. When a modified version is used to provide a service over a network, the complete source code of the modified version must be made available.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: [
      'include-copyright',
      'document-changes',
      'disclose-source',
      'network-use-disclose',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'apache-2.0': {
    key: 'apache-2.0',
    name: 'Apache License 2.0',
    spdx_id: 'Apache-2.0',
    url: 'https://api.github.com/licenses/apache-2.0',
    node_id: 'MDc6TGljZW5zZTI=',
    html_url: 'http://choosealicense.com/licenses/apache-2.0/',
    description:
      'A permissive license whose main conditions require preservation of copyright and license notices. Contributors provide an express grant of patent rights. Licensed works, modifications, and larger works may be distributed under different terms and without source code.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: ['include-copyright', 'document-changes'],
    limitations: ['trademark-use', 'liability', 'warranty'],
    featured: true,
  },
  'bsd-2-clause': {
    key: 'bsd-2-clause',
    name: 'BSD 2-Clause "Simplified" License',
    spdx_id: 'BSD-2-Clause',
    url: 'https://api.github.com/licenses/bsd-2-clause',
    node_id: 'MDc6TGljZW5zZTQ=',
    html_url: 'http://choosealicense.com/licenses/bsd-2-clause/',
    description:
      'A permissive license that comes in two variants, the <a href="/licenses/bsd-2-clause/">BSD 2-Clause</a> and <a href="/licenses/bsd-3-clause/">BSD 3-Clause</a>. Both have very minute differences to the MIT license.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file. Replace [year] with the current year and [fullname] with the name (or names) of the copyright holders.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright'],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'bsd-3-clause': {
    key: 'bsd-3-clause',
    name: 'BSD 3-Clause "New" or "Revised" License',
    spdx_id: 'BSD-3-Clause',
    url: 'https://api.github.com/licenses/bsd-3-clause',
    node_id: 'MDc6TGljZW5zZTU=',
    html_url: 'http://choosealicense.com/licenses/bsd-3-clause/',
    description:
      'A permissive license similar to the <a href="/licenses/bsd-2-clause/">BSD 2-Clause License</a>, but with a 3rd clause that prohibits others from using the name of the project or its contributors to promote derived products without written consent.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file. Replace [year] with the current year and [fullname] with the name (or names) of the copyright holders.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright'],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'bsl-1.0': {
    key: 'bsl-1.0',
    name: 'Boost Software License 1.0',
    spdx_id: 'BSL-1.0',
    url: 'https://api.github.com/licenses/bsl-1.0',
    node_id: 'MDc6TGljZW5zZTI4',
    html_url: 'http://choosealicense.com/licenses/bsl-1.0/',
    description:
      'A simple permissive license only requiring preservation of copyright and license notices for source (and not binary) distribution. Licensed works, modifications, and larger works may be distributed under different terms and without source code.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright--source'],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'cc0-1.0': {
    key: 'cc0-1.0',
    name: 'Creative Commons Zero v1.0 Universal',
    spdx_id: 'CC0-1.0',
    url: 'https://api.github.com/licenses/cc0-1.0',
    node_id: 'MDc6TGljZW5zZTY=',
    html_url: 'http://choosealicense.com/licenses/cc0-1.0/',
    description:
      'The <a href="https://creativecommons.org/publicdomain/zero/1.0/">Creative Commons CC0 Public Domain Dedication</a> waives copyright interest in a work you\'ve created and dedicates it to the world-wide public domain. Use CC0 to opt out of copyright entirely and ensure your work has the widest reach. As with the Unlicense and typical software licenses, CC0 disclaims warranties. CC0 is very similar to the Unlicense.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: [],
    limitations: ['liability', 'trademark-use', 'patent-use', 'warranty'],
    featured: false,
  },
  'epl-2.0': {
    key: 'epl-2.0',
    name: 'Eclipse Public License 2.0',
    spdx_id: 'EPL-2.0',
    url: 'https://api.github.com/licenses/epl-2.0',
    node_id: 'MDc6TGljZW5zZTMy',
    html_url: 'http://choosealicense.com/licenses/epl-2.0/',
    description:
      'This commercially-friendly copyleft license provides the ability to commercially license binaries; a modern royalty-free patent license grant; and the ability for linked works to use other licenses, including commercial ones.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'distribution',
      'modifications',
      'patent-use',
      'private-use',
    ],
    conditions: ['disclose-source', 'include-copyright', 'same-license'],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'gpl-2.0': {
    key: 'gpl-2.0',
    name: 'GNU General Public License v2.0',
    spdx_id: 'GPL-2.0',
    url: 'https://api.github.com/licenses/gpl-2.0',
    node_id: 'MDc6TGljZW5zZTg=',
    html_url: 'http://choosealicense.com/licenses/gpl-2.0/',
    description:
      'The GNU GPL is the most widely used free software license and has a strong copyleft requirement. When distributing derived works, the source code of the work must be made available under the same license. There are multiple variants of the GNU GPL, each with different requirements.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: [
      'include-copyright',
      'document-changes',
      'disclose-source',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  'gpl-3.0': {
    key: 'gpl-3.0',
    name: 'GNU General Public License v3.0',
    spdx_id: 'GPL-3.0',
    url: 'https://api.github.com/licenses/gpl-3.0',
    node_id: 'MDc6TGljZW5zZTk=',
    html_url: 'http://choosealicense.com/licenses/gpl-3.0/',
    description:
      'Permissions of this strong copyleft license are conditioned on making available complete source code of licensed works and modifications, which include larger works using a licensed work, under the same license. Copyright and license notices must be preserved. Contributors provide an express grant of patent rights.',
    implementation:
      'Create a text file (typically named COPYING, as per GNU conventions) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: [
      'include-copyright',
      'document-changes',
      'disclose-source',
      'same-license',
    ],
    limitations: ['liability', 'warranty'],
    featured: true,
  },
  'lgpl-2.1': {
    key: 'lgpl-2.1',
    name: 'GNU Lesser General Public License v2.1',
    spdx_id: 'LGPL-2.1',
    url: 'https://api.github.com/licenses/lgpl-2.1',
    node_id: 'MDc6TGljZW5zZTEx',
    html_url: 'http://choosealicense.com/licenses/lgpl-2.1/',
    description:
      'Primarily used for software libraries, the GNU LGPL requires that derived works be licensed under the same license, but works that only link to it do not fall under this restriction. There are two commonly used versions of the GNU LGPL.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: [
      'include-copyright',
      'disclose-source',
      'document-changes',
      'same-license--library',
    ],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
  mit: {
    key: 'mit',
    name: 'MIT License',
    spdx_id: 'MIT',
    url: 'https://api.github.com/licenses/mit',
    node_id: 'MDc6TGljZW5zZTEz',
    html_url: 'http://choosealicense.com/licenses/mit/',
    description:
      'A short and simple permissive license with conditions only requiring preservation of copyright and license notices. Licensed works, modifications, and larger works may be distributed under different terms and without source code.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file. Replace [year] with the current year and [fullname] with the name (or names) of the copyright holders.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'private-use',
    ],
    conditions: ['include-copyright'],
    limitations: ['liability', 'warranty'],
    featured: true,
  },
  'mpl-2.0': {
    key: 'mpl-2.0',
    name: 'Mozilla Public License 2.0',
    spdx_id: 'MPL-2.0',
    url: 'https://api.github.com/licenses/mpl-2.0',
    node_id: 'MDc6TGljZW5zZTE0',
    html_url: 'http://choosealicense.com/licenses/mpl-2.0/',
    description:
      'Permissions of this weak copyleft license are conditioned on making available source code of licensed files and modifications of those files under the same license (or in certain cases, one of the GNU licenses). Copyright and license notices must be preserved. Contributors provide an express grant of patent rights. However, a larger work using the licensed work may be distributed under different terms and without source code for files added in the larger work.',
    implementation:
      'Create a text file (typically named LICENSE or LICENSE.txt) in the root of your source code and copy the text of the license into the file.',
    permissions: [
      'commercial-use',
      'modifications',
      'distribution',
      'patent-use',
      'private-use',
    ],
    conditions: ['disclose-source', 'include-copyright', 'same-license--file'],
    limitations: ['liability', 'trademark-use', 'warranty'],
    featured: false,
  },
  unlicense: {
    key: 'unlicense',
    name: 'The Unlicense',
    spdx_id: 'Unlicense',
    url: 'https://api.github.com/licenses/unlicense',
    node_id: 'MDc6TGljZW5zZTE1',
    html_url: 'http://choosealicense.com/licenses/unlicense/',
    description:
      'A license with no conditions whatsoever which dedicates works to the public domain. Unlicensed works, modifications, and larger works may be distributed under different terms and without source code.',
    implementation:
      'Create a text file (typically named UNLICENSE or UNLICENSE.txt) in the root of your source code and copy the text of the license disclaimer into the file.',
    permissions: [
      'private-use',
      'commercial-use',
      'modifications',
      'distribution',
    ],
    conditions: [],
    limitations: ['liability', 'warranty'],
    featured: false,
  },
};
